// extracted by mini-css-extract-plugin
export default {"generate_table_form_container":"generate-table-form_generate_table_form_container__wnROP"};